<template>
  <div class="select-container">
    <div class="input-container">
      <input type="text" v-model="inputValue" />
      <div
        v-if="Number(tokenBalance) > 0 && showMax"
        class="max-text"
        @click.prevent="onClickMax"
      >
        MAX
      </div>
      <div class="input-suffix" @click.prevent="toggleOptions">
        <div>{{ selectedTokenSymbol }}</div>
        <img :src="require('@/assets/imgs/arrow_down.png')" alt="" />
      </div>
    </div>
    <div class="option-container" v-show="show">
      <div class="token-address-container">
        <input
          ref="addressInput"
          type="text"
          placeholder="Token Address"
          @focus="tokenAddressInputFocus"
          @blur="switchInputComplete"
          v-model="inputTokenAddress"
          v-if="!inputComplete"
        />
        <div
          v-else
          class="token-address-text"
          @click.prevent.stop="switchInputComplete"
        >
          {{ inputTokenAddressStr }}
        </div>
        <img :src="require('@/assets/imgs/enter.png')" />
      </div>
      <div
        :class="['option-box', isSelected(option) ? 'selected-option' : '']"
        v-for="option in options"
        @click.stop.prevent="onSelect(option)"
      >
        <div class="option-text">{{ option.symbol }}</div>
        <img
          :src="require('@/assets/imgs/selected.png')"
          v-show="isSelected(option)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "SelectToken",
  props: {
    options: Array,
    selected: String,
    value: String,
    input: String,
    tokenBalance: String | Number,
    tokenInfo: Object,
  },
  data() {
    return {
      selectedTokenSymbol: "",
      inputTokenAddress: "",
      inputTokenAddressStr: "",
      show: false,
      inputComplete: false,
      inputValue: "",
      showMax: false,
    };
  },
  mounted() {
    this.selectedTokenSymbol = this.selected;
  },
  computed: {},
  methods: {
    toggleOptions() {
      this.show = !this.show;
    },
    isSelected(option) {
      return option.symbol === this.selectedTokenSymbol;
    },
    onCreate(address) {
      this.$emit("on-create", address);
    },
    onSelect(option) {
      this.selectedTokenSymbol = option.symbol;
      this.$emit("input", option.address);
      this.$emit("on-select", option.address);
      this.inputValue = '';
      this.show = false;
      this.showMax = false;
    },
    onClickMax() {
      this.$emit("on-click-max", this.selectedTokenSymbol);
    },
    clipAddress() {
      return (
        this.inputTokenAddress.substr(0, 25) +
        "..." +
        this.inputTokenAddress.substr(-4)
      );
    },
    switchInputComplete() {
      this.inputComplete = !this.inputComplete;
    },
    tokenAddressInputFocus() {
      this.$refs.addressInput.select();
      this.inputComplete = false;
    },
  },

  watch: {
    inputTokenAddress: debounce(function (newValue) {
      if (!newValue) return;
      this.onCreate(newValue);
      this.inputTokenAddressStr = this.clipAddress();
      this.$refs.addressInput.blur();
    }, 500),
    inputComplete: function (newValue) {
      if (!newValue) {
        const _vue = this;
        setTimeout(function () {
          _vue.$refs.addressInput.focus();
        }, 200);
      }
    },
    show: function (newValue) {
      if (newValue) {
        this.inputTokenAddress = "";
        this.inputTokenAddressStr = "";
      }
    },
    input: function(newValue) {
      this.inputValue = newValue;
    },
    inputValue: debounce(function (newValue) {
      this.$emit("on-input", newValue);
    }, 500),

    "tokenInfo.symbol": function(newValue, oldValue) {
      this.showMax = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/fonts.scss";

.select-container {
  position: relative;
  background: #171717;
  border-radius: 12px;
  padding: 8px 18px;
  margin: 0 0 12px 0;

  .max-text {
    @include fontSize-12;
    @include mediumFont;
    color: #f72e54;
    cursor: pointer;

    &:hover {
      color: rgba(#f72e54, 0.7);
    }
  }

  input {
    outline: none;
    border: none;
    background: transparent;
  }

  .input-container {
    display: flex;
    align-items: center;
    color: rgba(#8f92a1, 0.6);

    @include fontSize-14;
    @include regularFont;

    img {
      width: 16px;
      height: 16px;
      margin: 0 0 0 8px;
    }

    input {
      flex: 1;
      padding: 0 18px 0 0;
      color: #8f92a1;
    }
  }

  .input-suffix {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 0 0 8px;
  }

  .option-container {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    border-radius: 12px;
    border: 1px solid #2a2b2f;
    padding: 8px 0;

    background: #202125;
    box-shadow: 0px 12px 20px 0px rgba(23, 23, 23, 0.46);
    z-index: 999;
    width: 100%;
    text-align: left;
    overflow: hidden;

    img {
      width: 12px;
      height: auto;
    }
  }

  .token-address-container {
    padding: 5px 12px;
    background: #171717;
    border-radius: 12px;
    margin: 0 8px 8px;
    display: flex;
    align-items: center;
    height: auto;

    @include fontSize-14;
    @include regularFont;

    input {
      width: 100%;
      height: 100%;
      color: #8f92a1;
      padding: 0 18px 0 0;
    }

    .token-address-text {
      width: 100%;
      height: 20px;
      color: #8f92a1;
      padding: 0 18px 0 0;
    }
  }

  .option-box {
    // margin: 8px 0 0 0;
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    &:hover {
      background: #12223b;
    }
  }

  .selected-option {
    background: #12223b;
  }
}
</style>
